module.exports = __webpack_public_path__ + "bcaa593cce611ca5448964c9b213012c.png";